import React from "react";

import { Header, Icon } from "semantic-ui-react";

export default () => {
  return (
    <div>
      <Header as="h2">
        <Icon name="calculator" />
        <Header.Content>
          Budget
          <Header.Subheader>Manage your spending.</Header.Subheader>
        </Header.Content>
      </Header>
    </div>
  );
};



// WEBPACK FOOTER //
// ./frontend/src/views/pages/BudgetView.js